/**
 * Display names for the Insurance-Related Partners legal page.
 * Combined from LaunchPadRules carrier configs and quote-outcome leadSources,
 * with official brand names verified against public vendor sites. Alphabetical, deduped.
 */
export const INSURANCE_RELATED_PARTNERS: readonly string[] = [
    "Adelie Risk Advisors",
    "All Web Leads (AWL)",
    "Archenia",
    "Astoria Company",
    "Berkshire Hathaway Homestate Companies (BHHC)",
    "Berxi",
    "biBERK",
    "BindRight",
    "BMG360",
    "Bold Penguin",
    "CNA Surety",
    "Commercial Insurance Center (CIC)",
    "Commercial Truck Quotes",
    "Cover Whale",
    "Creative Clicks",
    "ERGO NEXT",
    "GEICO",
    "Hiscox",
    "Homesite",
    "Intuit",
    "Liberty Mutual",
    "MediaBids",
    "MoneyGeek",
    "Motive",
    "MVF Global",
    "Mylo",
    "National Indemnity Company (NICO)",
    "Next Insurance",
    "Otto Insurance",
    "QuinStreet",
    "Ryan Specialty",
    "SimplyBusiness",
    "SmartFinancial",
    "Soleo",
    "Switchboard",
    "The Hartford",
    "Tivly",
    "ToXPAND",
    "Travelers",
    "Utica First",
    "Visiquia",
];
